import { showSuccessToast } from "./notifications";

/**
 * Share a URL via Web Share API, falling back to clipboard copy.
 */
export async function shareAppUrl({
  url,
  title,
  text,
  copySuccessMessage = "لینک در کلیپ‌بورد کپی شد.",
}) {
  if (!url) return;

  if (navigator.share) {
    try {
      await navigator.share({
        title: title || undefined,
        text: text || undefined,
        url,
      });
      return;
    } catch (err) {
      if (err?.name === "AbortError") return;
    }
  }

  try {
    await navigator.clipboard.writeText(url);
    showSuccessToast(copySuccessMessage);
    return;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = url;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand("copy");
      showSuccessToast(copySuccessMessage);
    } finally {
      document.body.removeChild(ta);
    }
  }
}
